import * as React from 'react';
import { CircularProgress, IconButton, ListItem, ListItemText } from '@mui/material';
import { Delete } from '@mui/icons-material';

import { IZoneCategoryDefaultServiceItem } from 'models';
import { useDeleteZoneCategoryServiceItemMutation } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface CategoryServiceItemProps {
  serviceItem: IZoneCategoryDefaultServiceItem;
}

export const CategoryServiceItem = ({
  serviceItem: { id, name, zone_category_id: categoryId },
}: CategoryServiceItemProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [mutate, { isLoading: isDeleting }] = useDeleteZoneCategoryServiceItemMutation();

  const onDelete = () => {
    mutate({ orgSlug, categoryId, id });
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="delete"
          color="primary"
          onClick={onDelete}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
          }}
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={18} color="inherit" /> : <Delete />}
        </IconButton>
      }
    >
      <ListItemText primary={name} />
    </ListItem>
  );
};
